var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { classNames } from '@shapeable/utils';
import React from 'react';
import styled, { css } from 'styled-components';
var cls = classNames('entity-toggle-button');
import { breakpoints, theme } from '@shapeable/theme';
export var IconToggleButtonDefaultProps = {
  isActive: false,
  onClick: function () {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    display: block;\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    opacity: 0.5;\n\n    ", "\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n  "], ["\n    font-family: ", ";\n    display: block;\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    opacity: 0.5;\n\n    ", "\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n  "])), theme.FONT('condensed'), theme.FONT_SIZE(11), theme.COLOR('light'), theme.FILL('light'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 1.0;\n    "], ["\n      opacity: 1.0;\n    "])));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 24px;\n  "], ["\n    width: 24px;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 40px;\n  "], ["\n    width: 40px;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    padding-top: ", ";\n  "])), theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var IconToggleButton = function (props) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    isActive = props.isActive,
    icon = props.icon;
  var handleClick = function (e) {
    e.stopPropagation();
    onClick(e);
  };
  return React.createElement(My.Container, {
    onClick: handleClick,
    isActive: isActive,
    className: cls.name(className)
  }, icon, React.createElement(My.Label, null, children));
};
IconToggleButton.defaultProps = IconToggleButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;